import { StringSchema, string } from 'yup';

export default function (this: StringSchema, message = 'Deve conter 4 caracteres') {
  return this.test('year', message, (value) => string().length(4).isValidSync(value));
}
